import Backbone from "backbone";
import { View } from "./base-database-reader";
import { DB_PROVIDERS } from "./configs/db-providers";

class MariaDBXpandIL extends View {
    setup() {
        this.model.get("connectionParams").set("type", DB_PROVIDERS.MARIADBXPAND.id);
    }
}

export default {
    View: MariaDBXpandIL,
    vent: new Backbone.Model()
};
